import { render, staticRenderFns } from "./selectedProductView.vue?vue&type=template&id=11b70b68&scoped=true&"
import script from "./selectedProductView.vue?vue&type=script&lang=js&"
export * from "./selectedProductView.vue?vue&type=script&lang=js&"
import style0 from "./selectedProductView.vue?vue&type=style&index=0&id=11b70b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b70b68",
  null
  
)

export default component.exports